import { brandLink, useGlobalFunc } from "../global/constants"
import { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import axios from 'axios'



import searchImg from '../assets/search.png'
import messageImg from '../assets/message.png'
import personImg from '../assets/person.png'
import shopbagImg from '../assets/shopbag.png'


import logoImg from '../assets/logo.png'
import titleLogoImg from '../assets/titlelogo.png'

import arrowImg from '../assets/arrow.png'
import arrowrightImg from '../assets/arrowright.png'
import globalImg from '../assets/global.png'

import logoutImg from '../assets/logout.png'

import menuImg from '../assets/menu.png'

import avatarImg from '../assets/avatar.png'

import closeImg from '../assets/close.png'
import closewtImg from '../assets/closewt.png'

import globalbkImg from '../assets/icon_global.png'


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { useSelector, useDispatch } from 'react-redux';
import ActionDialog from "./ActionDialog";
import AlertDialog from "./AlertDialog";
import UserApi from "../services/UserApi";



function DownWalletDialog(props) {
    const { onClose, selectedValue, open } = props;
    //const theme = useTheme();

    const [checkboxStatus, setCheckboxStatus] = useState(false)
    const [balanceWarning, setBalanceWarning] = useState(false)

    const [count, setCount] = useState(1)

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('768'));



    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };






    return (
        <Dialog maxWidth="2000" PaperProps={{ sx: { bgcolor: "transparent" } }} fullScreen={fullScreen} onClose={handleClose} open={open} >
            <div className="w-full h-full" onClick={handleClose}></div>
            <div className="lg:w-[510px] text-white absolute lg:relative bottom-0 left-0 w-full bg-[#1C1E21]  p-[28px] pt-[17px] rounded-t-md">
                <div className="relative py-7">

                    <div className="text-black absolute top-0 right-0 text-base font-medium"  >
                        <img className="w-6 h-6 object-contain cursor-pointer" alt="" onClick={handleClose} />
                    </div>



                    <p className="text-lg lg:text-2xl text-[#FFFFFF] mb-[37px] font-bold text-center ">使用 APP</p>



                    <div className="px-3 bg-[#FFFFFF] bg-opacity-10 rounded-[10px] pt-[64px] pb-[45px]">



                    </div>
                </div>


            </div>
        </Dialog>
    );
}

const Header = () => {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const { setLoading, errorToast } = useGlobalFunc()

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const userInfo = useSelector(state => state.userInfo);
    const menuData = useSelector(state => state.menu);

    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const { updateMe } = useGlobalFunc();

    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const openLang = Boolean(anchorEl);
    const handleLangClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleLangClose = () => {
        setAnchorEl(null);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        handleLangClose()
        return
        console.log(i18n.language)
        if (i18n.language == 'zh') {
            i18n.changeLanguage('en');
        }
        else {
            i18n.changeLanguage('zh');
        }

    };

    const [openMenuProductType, setOpenMenuProductType] = useState(false);

    const [openSelProductType, setOpenSelProductType] = useState(false);
    const [selProductTypeIndex, setSelProductTypeIndex] = useState(0);
    const productList = [
        {
            title: "肌膚照護",
            type: [
                {
                    subTitle: "基礎 Basic",
                    products: ['月夜之光月球皂', '土星賦活泉源噴霧', '星能奇蹟修護乳液']
                },
                {
                    subTitle: "特別修護 Extra Care",
                    products: ['天王星全能極淨精華霜', '天王星永恆時空精華霜', '水星賦活再生精華']
                },
                {
                    subTitle: "防護 Protection",
                    products: ['金星晶亮隔離EE霜', '金星煥膚潔淨精華']
                },
                {
                    subTitle: "私密 Private Care",
                    products: ['地球秘蜜柔淨慕思', '地球秘蜜柔嫩噴霧']
                }
            ]
        },
        {
            title: "健康照顧",
            type: [
                {
                    subTitle: "基礎 Basic",
                    products: ['火星燃溶膠囊', '流星益生晶球', '星能奇蹟修護乳液', '銀河鱸鰻精萃']
                }
            ]
        },
        {
            title: "醫療保養",
            type: [
                {
                    subTitle: "基礎 Basic",
                    products: ['海王星超能噴霧', '土星賦活泉源噴霧', '星能奇蹟修護乳液']
                }
            ]
        },
        {
            title: "寵物照顧",
            type: [
                {
                    subTitle: "基礎 Basic",
                    products: ['彗星寵膚沐浴皂', '彗星寵膚超能精華', '彗星寵膚驚奇保護噴霧']
                }
            ]
        },


    ]


    const [isTransparentMenu, setIsTransparentMenu] = useState(false);

    const routeList = [

        {
            img: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M12 22.5C9.34784 22.5 6.8043 21.4464 4.92893 19.5711C3.05357 17.6957 2 15.1522 2 12.5C2 9.84784 3.05357 7.3043 4.92893 5.42893C6.8043 3.55357 9.34784 2.5 12 2.5C14.6522 2.5 17.1957 3.55357 19.0711 5.42893C20.9464 7.3043 22 9.84784 22 12.5C22 15.1522 20.9464 17.6957 19.0711 19.5711C17.1957 21.4464 14.6522 22.5 12 22.5ZM12.315 6.335C12.2442 6.2904 12.1648 6.26123 12.082 6.2494C11.9991 6.23757 11.9147 6.24335 11.8343 6.26635C11.7538 6.28935 11.6791 6.32907 11.6151 6.3829C11.551 6.43673 11.499 6.50346 11.4625 6.57875L9.9625 9.61875L6.6075 10.1062C6.49662 10.1215 6.39227 10.1677 6.30639 10.2394C6.22051 10.3112 6.15657 10.4057 6.12188 10.5121C6.08719 10.6186 6.08315 10.7326 6.11023 10.8412C6.13731 10.9498 6.19441 11.0486 6.275 11.1263L8.705 13.4913L8.13 16.8337C8.11155 16.9436 8.1241 17.0564 8.16626 17.1595C8.20842 17.2626 8.27851 17.352 8.36864 17.4174C8.45878 17.4829 8.56538 17.5219 8.67648 17.5301C8.78757 17.5383 8.89875 17.5153 8.9975 17.4637L12 15.8862L15 17.4625C15.0987 17.5145 15.21 17.5379 15.3213 17.5299C15.4326 17.522 15.5395 17.483 15.6298 17.4174C15.7201 17.3519 15.7902 17.2623 15.8322 17.1589C15.8742 17.0555 15.8865 16.9425 15.8675 16.8325L15.295 13.4913L17.7225 11.125C17.8018 11.047 17.8577 10.9484 17.8841 10.8403C17.9104 10.7323 17.9062 10.619 17.8718 10.5132C17.8374 10.4074 17.7742 10.3133 17.6894 10.2415C17.6045 10.1696 17.5012 10.1228 17.3912 10.1062L14.035 9.61875L12.535 6.57875C12.4862 6.47836 12.4099 6.39385 12.315 6.335Z" fill="currentColor" />
            </svg>,
            title: 'aboutUs',
            path: "/aboutus",
        },
        {
            img: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M3 19.3C3 20.83 4.17 22 5.7 22H18.3C19.83 22 21 20.83 21 19.3V12.1H3V19.3ZM18.3 5.8H16.5V4.9C16.5 4.36 16.14 4 15.6 4C15.06 4 14.7 4.36 14.7 4.9V5.8H9.3V4.9C9.3 4.36 8.94 4 8.4 4C7.86 4 7.5 4.36 7.5 4.9V5.8H5.7C4.17 5.8 3 6.97 3 8.5V10.3H21V8.5C21 6.97 19.83 5.8 18.3 5.8Z" fill="currentColor" />
            </svg>,
            title: 'contactUs',
            path: "/contactus",
        },
    ]

    const moreRouteList = [

        // {
        //     img: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        //         <path d="M14.1733 20.4166C15.1104 20.4166 15.6055 21.526 14.9804 22.2236C14.5743 22.6781 14.0768 23.0415 13.5204 23.2902C12.9641 23.5389 12.3615 23.6672 11.752 23.6666C11.1426 23.6672 10.54 23.5389 9.98366 23.2902C9.4273 23.0415 8.92979 22.6781 8.52372 22.2236C7.92572 21.5563 8.35255 20.5131 9.21055 20.4242L9.32972 20.4177L14.1733 20.4166ZM11.752 2C13.2232 2 14.4669 2.97825 14.8666 4.31941L14.9165 4.50466L14.9251 4.55125C16.1194 5.22497 17.1371 6.17202 17.8948 7.31483C18.6525 8.45763 19.1287 9.76368 19.2845 11.126L19.3148 11.4369L19.3354 11.75V14.9252L19.3581 15.0726C19.5065 15.8708 19.9482 16.5846 20.5964 17.0735L20.7773 17.2002L20.9528 17.3075C21.8845 17.8351 21.5595 19.2206 20.5444 19.3268L20.4187 19.3333H3.08539C1.97173 19.3333 1.58281 17.8557 2.55131 17.3075C2.96409 17.0739 3.32074 16.7528 3.59623 16.3667C3.87171 15.9806 4.05935 15.5389 4.14597 15.0726L4.16872 14.9177L4.16981 11.7002C4.23586 10.2852 4.64773 8.90799 5.36936 7.68908C6.091 6.47018 7.1004 5.44674 8.30922 4.70833L8.57789 4.55016L8.58872 4.50358C8.74196 3.85578 9.09024 3.27057 9.58656 2.82695C10.0829 2.38332 10.7033 2.10263 11.3642 2.02275L11.5614 2.00433L11.752 2Z" fill="currentColor" />
        //     </svg>,
        //     title: 'message',
        //     path: "/membercenter/message",
        // },

        // {
        //     img: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        //         <path d="M12 22.5C9.34784 22.5 6.8043 21.4464 4.92893 19.5711C3.05357 17.6957 2 15.1522 2 12.5C2 9.84784 3.05357 7.3043 4.92893 5.42893C6.8043 3.55357 9.34784 2.5 12 2.5C14.6522 2.5 17.1957 3.55357 19.0711 5.42893C20.9464 7.3043 22 9.84784 22 12.5C22 15.1522 20.9464 17.6957 19.0711 19.5711C17.1957 21.4464 14.6522 22.5 12 22.5ZM12.315 6.335C12.2442 6.2904 12.1648 6.26123 12.082 6.2494C11.9991 6.23757 11.9147 6.24335 11.8343 6.26635C11.7538 6.28935 11.6791 6.32907 11.6151 6.3829C11.551 6.43673 11.499 6.50346 11.4625 6.57875L9.9625 9.61875L6.6075 10.1062C6.49662 10.1215 6.39227 10.1677 6.30639 10.2394C6.22051 10.3112 6.15657 10.4057 6.12188 10.5121C6.08719 10.6186 6.08315 10.7326 6.11023 10.8412C6.13731 10.9498 6.19441 11.0486 6.275 11.1263L8.705 13.4913L8.13 16.8337C8.11155 16.9436 8.1241 17.0564 8.16626 17.1595C8.20842 17.2626 8.27851 17.352 8.36864 17.4174C8.45878 17.4829 8.56538 17.5219 8.67648 17.5301C8.78757 17.5383 8.89875 17.5153 8.9975 17.4637L12 15.8862L15 17.4625C15.0987 17.5145 15.21 17.5379 15.3213 17.5299C15.4326 17.522 15.5395 17.483 15.6298 17.4174C15.7201 17.3519 15.7902 17.2623 15.8322 17.1589C15.8742 17.0555 15.8865 16.9425 15.8675 16.8325L15.295 13.4913L17.7225 11.125C17.8018 11.047 17.8577 10.9484 17.8841 10.8403C17.9104 10.7323 17.9062 10.619 17.8718 10.5132C17.8374 10.4074 17.7742 10.3133 17.6894 10.2415C17.6045 10.1696 17.5012 10.1228 17.3912 10.1062L14.035 9.61875L12.535 6.57875C12.4862 6.47836 12.4099 6.39385 12.315 6.335Z" fill="currentColor" />
        //     </svg>,
        //     title: 'news',
        //     path: "/news",
        // },
        {
            img: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M3 19.3C3 20.83 4.17 22 5.7 22H18.3C19.83 22 21 20.83 21 19.3V12.1H3V19.3ZM18.3 5.8H16.5V4.9C16.5 4.36 16.14 4 15.6 4C15.06 4 14.7 4.36 14.7 4.9V5.8H9.3V4.9C9.3 4.36 8.94 4 8.4 4C7.86 4 7.5 4.36 7.5 4.9V5.8H5.7C4.17 5.8 3 6.97 3 8.5V10.3H21V8.5C21 6.97 19.83 5.8 18.3 5.8Z" fill="currentColor" />
            </svg>,
            title: 'calendar',
            isLink: true,
            path: "https://calendar.google.com/calendar/u/0/embed?src=alphamars.co@gmail.com&ctz=Asia/Taipei",
        },
    ]




    const [currPath, setCurrPath] = useState()
    const [showStoryMenu, setShowStoryMenu] = useState(false)



    function saveScrollId(scrollId) {
        console.log('sss')
        localStorage.setItem('scrollId', scrollId)

        scroller.scrollTo(scrollId, { smooth: true, offset: -150 })

        console.log(localStorage.getItem('scrollId'))
    }


    function isCurrentPath(selPath) {
        let path = location.pathname.split("/");
        if (location.pathname == selPath) {
            return true

        }
        //console.log(path, selPath)
        if ('/' + path[1] == selPath) {
            return true
        }
        else {
            return false
        }

    }

    function navigatePath(path) {
        setShowStoryMenu(false)
        navigate(path)
        setOpenSelProductType(false)
        window.scroll(0, 0)
    }

    function goToUserInfo() {
        if (userInfo) {
            navigate('/membercenter/userinfo')
        }
        else {
            navigate('/login')
        }

    }


    function logout() {
        localStorage.removeItem('userToken')
        dispatch({
            type: "UPDATE_USERINFO",
            payload: { userInfo: null }
        });
        navigate('/')
        window.location.reload()
    }

    async function getMenu() {
        setLoading(true)
        try {
            let res = await UserApi.productCategorySearch()
            console.log(res.data.data)

            const sortedData = res.data.data.reverse().sort((a, b) => {
                if (a.isShoppingPointPackage && !b.isShoppingPointPackage) {
                  return 1; 
                } else if (!a.isShoppingPointPackage && b.isShoppingPointPackage) {
                  return -1; 
                } else {
                  return 0; 
                }
              });
            dispatch({
                type: "UPDATE_MENU",
                payload: { menu: sortedData }
            });

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)
    }


    useEffect(() => {
        getMenu()

        const token = query.get('token')
        if (token != null && window.location.pathname == '/login') {
            localStorage.setItem("userAuth", token)
        }

        //if (localStorage.getItem('userAuth') != null){
        updateMe()
        //}
    }, [])

    useEffect(() => {
        if (location.pathname == "/" || location.pathname == "/aboutus" || location.pathname == "/contactus" || location.pathname == "/producttype") {
            setIsTransparentMenu(true)
        }
        else {
            setIsTransparentMenu(false)
        }

    }, [location.pathname])

    return <div className="relative">
        <ToastContainer closeButton={false} icon={false} position="top-center" toastClassName="!rounded !overflow-hidden !bg-main !bg-opacity-90  !backdrop-blur-sm mb-1 !border !border-solid !border-main" className=" !p-2  " bodyClassName={() => "flex items-center text-black9"} />

        {true ?
            <div className={`${showStoryMenu ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"} anim  fixed w-screen h-screen  left-0 top-0 z-30 `}>
                <div className=" absolute left-0 top-0 w-full h-full bg-black bg-opacity-40" onClick={() => setShowStoryMenu(false)}>
                </div>
                <div className="overflow-scroll  relative flex flex-col  bg-black ml-auto  w-[320px] px-3 h-full shadow-me ">
                    <div className=" relative w-full h-full mx-auto  ">


                        <div className="bg-black p-4 mb-8">
                            <div className="relative w-full py-2 mb-4">
                                <div className="w-full flex items-center justify-end   ">

                                    <img className="w-6 h-6 object-contain cursor-pointer" src={closewtImg} alt="" onClick={() => setShowStoryMenu(false)} />
                                </div>
                            </div>
                            {
                                userInfo != null ?
                                    <>
                                        <div onClick={() => navigatePath("/membercenter")} className=" cursor-pointer mb-4 flex items-center font-bold">
                                            <img className=" object-contain w-[30px] h-[30px] mr-6" src={personImg} alt="" />
                                            會員中心
                                        </div>
                                        <div onClick={() => navigatePath("/cart")} className={` cursor-pointer  mb-4 flex items-center font-bold `}>
                                            <img className=" object-contain w-[30px] h-[30px] mr-6" src={shopbagImg} alt="" />
                                            購物車
                                        </div>
                                        <div onClick={() => navigatePath("/membercenter/message")} className={` cursor-pointer  mb-4 flex items-center font-bold `}>
                                            <svg className="mr-6" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 25" fill="none">
                                                <path d="M14.1733 20.4166C15.1104 20.4166 15.6055 21.526 14.9804 22.2236C14.5743 22.6781 14.0768 23.0415 13.5204 23.2902C12.9641 23.5389 12.3615 23.6672 11.752 23.6666C11.1426 23.6672 10.54 23.5389 9.98366 23.2902C9.4273 23.0415 8.92979 22.6781 8.52372 22.2236C7.92572 21.5563 8.35255 20.5131 9.21055 20.4242L9.32972 20.4177L14.1733 20.4166ZM11.752 2C13.2232 2 14.4669 2.97825 14.8666 4.31941L14.9165 4.50466L14.9251 4.55125C16.1194 5.22497 17.1371 6.17202 17.8948 7.31483C18.6525 8.45763 19.1287 9.76368 19.2845 11.126L19.3148 11.4369L19.3354 11.75V14.9252L19.3581 15.0726C19.5065 15.8708 19.9482 16.5846 20.5964 17.0735L20.7773 17.2002L20.9528 17.3075C21.8845 17.8351 21.5595 19.2206 20.5444 19.3268L20.4187 19.3333H3.08539C1.97173 19.3333 1.58281 17.8557 2.55131 17.3075C2.96409 17.0739 3.32074 16.7528 3.59623 16.3667C3.87171 15.9806 4.05935 15.5389 4.14597 15.0726L4.16872 14.9177L4.16981 11.7002C4.23586 10.2852 4.64773 8.90799 5.36936 7.68908C6.091 6.47018 7.1004 5.44674 8.30922 4.70833L8.57789 4.55016L8.58872 4.50358C8.74196 3.85578 9.09024 3.27057 9.58656 2.82695C10.0829 2.38332 10.7033 2.10263 11.3642 2.02275L11.5614 2.00433L11.752 2Z" fill="currentColor" />
                                            </svg>
                                            訊息中心 {userInfo && userInfo.unreadCount > 0 && < span className="text-red1 bg-black px-2 py-0.5 rounded-full text-sm">{userInfo.unreadCount}</span>}
                                        </div>
                                        <button className="object-contain w-full px-4 h-[36px] font-bold text-sm border-white border border-solid rounded-lg" onClick={() => logout()}>
                                            登出
                                        </button>
                                    </>
                                    :
                                    <Link to="/login" onClick={() => showStoryMenu(false)}>
                                        <button className="w-full object-contain px-4 h-[36px] font-bold text-sm bg-white text-main8 rounded-lg" >
                                            登入
                                        </button>
                                    </Link>

                            }
                        </div>
                        <div className="px-0">
                            <div className={`relative rounded-lg    `} >
                                <p onClick={() => setOpenMenuProductType(!openMenuProductType)} className={`${(isCurrentPath('producttype')) ? " bg-red1 text-black99" : "text-white"} font-bold px-5 py-4 w-full flex justify-start items-center cursor-pointer   `}>產品分類</p>
                                {
                                    menuData && openMenuProductType &&
                                    <div className=" bg-black bg-opacity-[0.85]  w-full  flex pb-[10px]">
                                        <div className="w-full ">
                                            {
                                                menuData.map((i, index) => <div onClick={() => navigatePath('/producttype?categoryId=' + i.id)} key={index} className={` hover:bg-red1 hover:text-black99 text-white cursor-pointer text-sm flex justify-between items-center px-7 py-3  font-bold w-full`}>
                                                    <p>{i.name}</p>

                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                        <path d="M8.33333 14.6668L12.5 10.5002L8.33333 6.3335" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>

                                                </div>)
                                            }
                                        </div>


                                    </div>
                                }
                            </div>

                            {
                                routeList.map((i, index) =>
                                    <Link key={index} to={i.path} className={`${(isCurrentPath(i.path)) ? " bg-red1 text-black99" : "text-white"} font-bold px-5 py-4 w-full flex justify-start items-center cursor-pointer   `} onClick={() => setShowStoryMenu(false)}>

                                        <p className=" text-base ">{t(`header.${i.title}`)}</p>
                                    </Link>

                                )
                            }

                            {
                                moreRouteList.map((i, index) => {
                                    return i.isLink ?
                                        <a href={i.path} target="_blank" className="text-white font-bold px-5 py-4 w-full flex justify-start items-center cursor-pointer  ">
                                            <p className=" text-base ">{t(`header.${i.title}`)}</p>
                                        </a>
                                        :
                                        <Link key={index} to={i.path} className={`${(isCurrentPath(i.path)) ? " bg-red1 text-black99" : "text-white"} font-bold px-5 py-4 w-full flex justify-start items-center cursor-pointer   `} onClick={() => setShowStoryMenu(false)}>

                                            <p className=" text-base ">{t(`header.${i.title}`)}</p>
                                        </Link>
                                }

                                )
                            }



                            <div className="hidden">
                                <div className={"  rounded-lg w-full flex justify-between items-center cursor-pointer text-black08  mt-10 "} onClick={handleLangClick}>
                                    <div className="flex">
                                        <img className="w-6 h-6 object-contain cursor-pointer" src={globalbkImg} alt="" />
                                        <p className="ml-2 text-base "></p>
                                    </div>
                                    <div className="flex items-center ">
                                        <div className="text-sm relative  w-full  text-[#888888] whitespace-nowrap mr-2" >{i18n.language == "zh" ? "中文" : "EN"}</div>
                                        <img className="w-4 h-4" src={arrowrightImg} />

                                    </div>
                                </div>

                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={openLang}
                                    onClose={handleLangClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                >
                                    <MenuItem onClick={e => changeLanguage('zh')}>中文</MenuItem>
                                    <MenuItem onClick={e => changeLanguage('en')}>EN</MenuItem>
                                </Menu>


                            </div>

                            <div className="  h-10">
                            </div>

                        </div>


                    </div>


                </div>
            </div>

            : ""}


        {
            location.pathname != '/' &&
            <div className="hidden xl:block z-10  fixed right-1/2 bottom-20 translate-x-[600px] ">
                <svg className=" cursor-pointer" onClick={() => window.scroll(0, 0)} xmlns="http://www.w3.org/2000/svg" width="48" height="62" viewBox="0 0 48 62" fill="none">
                    <g clip-path="url(#clip0_510_7741)">
                        <path d="M42.0206 22.2234H42.0634L24.0031 0L5.94275 22.2234H5.9855C2.93691 25.6829 0.952419 29.9466 0.269916 34.5035C-0.412586 39.0603 0.235858 43.717 2.13752 47.9153C4.03919 52.1136 7.11337 55.6753 10.9916 58.1736C14.8698 60.6718 19.3875 62.0006 24.0031 62.0006C28.6187 62.0006 33.1363 60.6718 37.0145 58.1736C40.8928 55.6753 43.9669 52.1136 45.8686 47.9153C47.7703 43.717 48.4187 39.0603 47.7362 34.5035C47.0537 29.9466 45.0692 25.6829 42.0206 22.2234Z" fill="#E0836F" />
                        <path d="M35.6809 29.6068C35.6453 29.5876 35.6054 29.5775 35.5649 29.5775C35.5243 29.5775 35.4845 29.5876 35.4488 29.6068L30.1779 33.7283C30.1547 33.7459 30.1351 33.768 30.1204 33.7931C30.1056 33.8183 30.096 33.8461 30.092 33.875C30.0881 33.9038 30.0898 33.9332 30.0972 33.9614C30.1046 33.9896 30.1175 34.0161 30.1352 34.0393C30.1528 34.0625 30.1749 34.082 30.2001 34.0967C30.2253 34.1114 30.2531 34.121 30.2821 34.125C30.311 34.129 30.3404 34.1272 30.3686 34.1198C30.3969 34.1124 30.4234 34.0996 30.4467 34.082L34.5021 30.9115V46.41H35.5893C35.6179 46.4108 35.6463 46.4059 35.673 46.3955C35.6996 46.3852 35.7239 46.3696 35.7444 46.3497C35.7649 46.3298 35.7812 46.306 35.7923 46.2797C35.8035 46.2534 35.8092 46.2252 35.8092 46.1966V29.808C35.8088 29.7658 35.7965 29.7246 35.7739 29.6891C35.7512 29.6535 35.719 29.625 35.6809 29.6068Z" fill="white" />
                        <path d="M31.0696 43.8982C30.9941 43.9876 30.9009 44.0603 30.7957 44.1118C30.6905 44.1632 30.5758 44.1922 30.4588 44.1969C30.2721 44.1864 30.09 44.1351 29.9253 44.0466C29.7607 43.9581 29.6175 43.8346 29.506 43.6848C29.1397 43.2242 28.8546 42.7046 28.6631 42.1483C28.9075 41.6159 29.1334 41.0611 29.3411 40.4839C29.5488 39.9047 29.732 39.3072 29.8969 38.6914L30.7947 35.1795H28.596L27.7531 38.7158C27.5721 37.6097 27.0514 36.587 26.2628 35.7892C25.5263 35.132 24.5626 34.7866 23.5755 34.8259C22.8894 34.8251 22.2112 34.971 21.5864 35.2539C20.9617 35.5368 20.4049 35.9501 19.9536 36.466C18.9619 37.4963 18.412 38.8721 18.4206 40.301C18.3673 41.7877 18.9027 43.2355 19.9109 44.3311C20.3831 44.8485 20.9613 45.2584 21.6063 45.533C22.2512 45.8076 22.9478 45.9404 23.6488 45.9224C24.5528 45.9422 25.4428 45.6963 26.2079 45.2151C27.0458 44.6191 27.7353 43.839 28.2234 42.9349C28.379 43.7687 28.6787 44.5691 29.109 45.3005C29.2524 45.4975 29.4422 45.6562 29.6616 45.7625C29.8811 45.8689 30.1234 45.9196 30.3672 45.9102C30.5916 45.921 30.8147 45.8698 31.0119 45.7623C31.2091 45.6547 31.3728 45.4949 31.4849 45.3005C31.7671 44.6927 31.893 44.0242 31.8513 43.3555V43.0995H31.3933C31.3689 43.3923 31.256 43.6708 31.0696 43.8982ZM26.043 44.2091C25.8153 44.5591 25.5014 44.8449 25.1314 45.0392C24.7614 45.2335 24.3476 45.3298 23.9297 45.3188C23.4718 45.3352 23.0183 45.2255 22.6186 45.0018C22.219 44.7782 21.8887 44.4491 21.6638 44.0506C21.0854 42.9213 20.8177 41.6589 20.8881 40.3924C20.8259 39.1676 21.1117 37.9502 21.7126 36.8806C21.9357 36.486 22.2609 36.1584 22.6541 35.9321C23.0473 35.7058 23.4942 35.5891 23.948 35.5941C24.3629 35.5852 24.7737 35.6771 25.145 35.8619C25.5163 36.0467 25.8371 36.3189 26.0796 36.655C26.7637 37.7119 27.2193 38.8997 27.4172 40.1424C27.0141 42.0975 26.556 43.4429 26.043 44.1786V44.2091Z" fill="white" />
                        <path d="M20.1552 34.143C20.178 34.1214 20.1961 34.0954 20.2084 34.0665C20.2208 34.0377 20.2272 34.0067 20.2272 33.9753C20.2272 33.944 20.2208 33.913 20.2084 33.8842C20.1961 33.8553 20.178 33.8293 20.1552 33.8077L14.8172 29.6374C14.7499 29.5825 14.6658 29.5523 14.579 29.552H13.5284V46.404H14.6156C14.6442 46.4048 14.6726 46.3999 14.6993 46.3895C14.7259 46.3792 14.7502 46.3636 14.7707 46.3437C14.7912 46.3238 14.8075 46.3 14.8186 46.2737C14.8298 46.2474 14.8355 46.2192 14.8355 46.1906V30.2653L19.8193 34.143C19.864 34.1873 19.9243 34.2122 19.9873 34.2122C20.0502 34.2122 20.1106 34.1873 20.1552 34.143Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_510_7741">
                            <rect width="48" height="62" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </div>
        }

        <div className={`hidden lg:block fixed left-0 top-0 w-full h-[66px] ${isTransparentMenu ? " to-[#0000007f] from-transparent bg-gradient-to-t " : "bg-black shadow-md"}     z-20 px-10`}>

            <div className="relative w-full h-full flex justify-between items-center ">

                <Link to={'/'} className="relative w-1/3" >
                    <img className=" object-contain h-[20px] " src={titleLogoImg} alt="" />
                </Link>


                <div className="w-full h-full justify-center flex gap-4 items-center  ">

                    <div onMouseLeave={() => setOpenSelProductType(false)} className={`relative rounded-lg  flex justify-start items-center  px-3 `} onClick={() => setShowStoryMenu(false)}>
                        <p onMouseEnter={() => setOpenSelProductType(true)} className=" text-center  text-sm font-bold py-4 cursor-default">產品分類</p>
                        {
                            openSelProductType &&
                            <div className=" bg-black bg-opacity-[0.85] absolute -left-20 top-10 w-[650px] min-h-[300px] flex py-[20px]">
                                <div className="w-[200px] flex-none ">
                                    {
                                        menuData && menuData.map((i, index) => <div onClick={() => navigatePath('/producttype?categoryId=' + i.id)} onMouseEnter={() => setSelProductTypeIndex(index)} key={index} className={`${selProductTypeIndex == index ? "bg-red1 text-black99" : " text-black8"} cursor-pointer text-sm flex justify-between items-center px-9 py-3  font-bold w-full`}>
                                            <p>{i.name}</p>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                <path d="M8.33333 14.6668L12.5 10.5002L8.33333 6.3335" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                        </div>)
                                    }
                                </div>
                                <div className="grow p-4 ">
                                    <div className="grid grid-cols-2 gap-4">
                                        {
                                            menuData && menuData.length > 0 && menuData[selProductTypeIndex].subcategories.slice(0, 6).map(i => <div className="group">
                                                <p className="text-base font-bold text-white group-hover:text-red1  mb-4">{i.name}</p>
                                                {
                                                    i.products.slice(0, 3).map(item => <p onClick={() => navigatePath('/product/' + item.id)} className="text-sm text-white hover:text-red1 hover:underline mb-2 cursor-pointer">
                                                        {item.name}
                                                    </p>)
                                                }


                                            </div>)

                                        }

                                    </div>

                                    {
                                        menuData && menuData.length > 0 && menuData[selProductTypeIndex].subcategories.some(subcategory => subcategory.products.length > 2) &&
                                        <button onClick={() => navigatePath('/producttype?categoryId=' + menuData[selProductTypeIndex].id)} className="text-red1 hover:underline text-xs">查看更多</button>
                                    }
                                </div>

                            </div>
                        }
                    </div>
                    {
                        routeList.map((i, index) =>
                            <Link key={index} to={i.path} className={`${(isCurrentPath(i.path)) ? " text-white bg-red1  " : "text-white "} " px-3 py-0.5 rounded-full  flex justify-start items-center  cursor-pointer "`} >

                                <p className="text-center  text-sm font-bold ">{t(`header.${i.title}`)}</p>
                            </Link>

                        )
                    }
                </div>

                <div className="w-1/3 flex justify-end items-center gap-4">

                    {
                        userInfo && <>

                            <div className="w-7 h-7 relative cursor-pointer" onClick={() => navigate('/membercenter/message')}>
                                {
                                    userInfo && userInfo.unreadCount > 0 &&
                                    <div className="bg-red-500 w-2 h-2 rounded-full absolute right-0 top-0"></div>
                                }
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                    <path d="M17.0983 22.4C18.1835 22.4 18.7569 23.6288 18.033 24.4016C17.5627 24.9049 16.9865 25.3075 16.3422 25.583C15.6978 25.8585 14.9999 26.0006 14.2941 26C13.5884 26.0006 12.8904 25.8585 12.2461 25.583C11.6018 25.3075 11.0256 24.9049 10.5553 24.4016C9.86275 23.6624 10.3571 22.5068 11.3508 22.4084L11.4888 22.4012L17.0983 22.4ZM14.2941 2C15.9979 2 17.4383 3.0836 17.9012 4.5692L17.9589 4.7744L17.969 4.826C19.3521 5.57228 20.5307 6.62132 21.4082 7.8872C22.2858 9.15307 22.8373 10.5998 23.0176 12.1088L23.0528 12.4532L23.0766 12.8V16.3172L23.103 16.4804C23.2748 17.3646 23.7863 18.1553 24.537 18.6968L24.7465 18.8372L24.9498 18.956C26.0288 19.5404 25.6524 21.0752 24.4768 21.1928L24.3313 21.2H4.25702C2.96725 21.2 2.51684 19.5632 3.63849 18.956C4.11654 18.6972 4.52959 18.3415 4.84864 17.9139C5.16768 17.4862 5.38499 16.9969 5.48532 16.4804L5.51166 16.3088L5.51292 12.7448C5.58942 11.1775 6.06641 9.65193 6.90216 8.30176C7.73791 6.95159 8.90693 5.81793 10.3069 5L10.618 4.8248L10.6306 4.7732C10.8081 4.05563 11.2114 3.4074 11.7862 2.916C12.361 2.4246 13.0796 2.11368 13.845 2.0252L14.0733 2.0048L14.2941 2Z" fill="white" />
                                </svg>
                            </div>

                            <svg className=" cursor-pointer" onClick={() => navigate('/cart')} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path fillRule="evenodd" clip-rule="evenodd" d="M8.40001 6.9999V8.3999H6.53381C5.92096 8.40004 5.33041 8.62985 4.87868 9.044C4.42695 9.45816 4.14684 10.0266 4.09361 10.6371L2.93721 23.9371C2.90772 24.2753 2.94885 24.616 3.05799 24.9375C3.16713 25.259 3.3419 25.5543 3.57121 25.8047C3.80052 26.055 4.07937 26.255 4.39005 26.3919C4.70074 26.5288 5.03649 26.5996 5.37601 26.5999H22.624C22.9636 26.5998 23.2995 26.5291 23.6104 26.3923C23.9213 26.2555 24.2003 26.0556 24.4297 25.8052C24.6592 25.5548 24.8341 25.2594 24.9433 24.9378C25.0525 24.6162 25.0937 24.2754 25.0642 23.9371L23.9078 10.6371C23.8546 10.0263 23.5742 9.45772 23.1222 9.04353C22.6702 8.62934 22.0793 8.39969 21.4662 8.3999H19.6V6.9999C19.6 5.51469 19.01 4.09031 17.9598 3.0401C16.9096 1.9899 15.4852 1.3999 14 1.3999C12.5148 1.3999 11.0904 1.9899 10.0402 3.0401C8.99 4.09031 8.40001 5.51469 8.40001 6.9999ZM14 3.4999C13.0717 3.4999 12.1815 3.86865 11.5251 4.52503C10.8688 5.18141 10.5 6.07164 10.5 6.9999V8.3999H17.5V6.9999C17.5 6.07164 17.1313 5.18141 16.4749 4.52503C15.8185 3.86865 14.9283 3.4999 14 3.4999ZM10.5 13.9999C10.5 14.9282 10.8688 15.8184 11.5251 16.4748C12.1815 17.1312 13.0717 17.4999 14 17.4999C14.9283 17.4999 15.8185 17.1312 16.4749 16.4748C17.1313 15.8184 17.5 14.9282 17.5 13.9999V12.2499C17.5 11.9714 17.6106 11.7044 17.8075 11.5074C18.0045 11.3105 18.2715 11.1999 18.55 11.1999C18.8285 11.1999 19.0956 11.3105 19.2925 11.5074C19.4894 11.7044 19.6 11.9714 19.6 12.2499V13.9999C19.6 15.4851 19.01 16.9095 17.9598 17.9597C16.9096 19.0099 15.4852 19.5999 14 19.5999C12.5148 19.5999 11.0904 19.0099 10.0402 17.9597C8.99 16.9095 8.40001 15.4851 8.40001 13.9999V12.2499C8.40001 11.9714 8.51063 11.7044 8.70754 11.5074C8.90446 11.3105 9.17153 11.1999 9.45001 11.1999C9.72848 11.1999 9.99556 11.3105 10.1925 11.5074C10.3894 11.7044 10.5 11.9714 10.5 12.2499V13.9999Z" fill="white" />
                            </svg>

                            <svg className=" cursor-pointer" onClick={() => goToUserInfo()} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <g clip-path="url(#clip0_505_7043)">
                                    <path d="M14 1C6.824 1 1 6.824 1 14C1 21.176 6.824 27 14 27C21.176 27 27 21.176 27 14C27 6.824 21.176 1 14 1ZM14 4.9C16.158 4.9 17.9 6.642 17.9 8.8C17.9 10.958 16.158 12.7 14 12.7C11.842 12.7 10.1 10.958 10.1 8.8C10.1 6.642 11.842 4.9 14 4.9ZM14 23.36C10.75 23.36 7.877 21.696 6.2 19.174C6.239 16.587 11.4 15.17 14 15.17C16.587 15.17 21.761 16.587 21.8 19.174C20.123 21.696 17.25 23.36 14 23.36Z" fill="white" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_505_7043">
                                        <rect width="28" height="28" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </>
                    }
                    <svg className=" cursor-pointer" onClick={() => setShowStoryMenu(true)} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M3 6H7.125M25 6H12.625M25 23H20.875M3 23H15.375M3 14.5H25" stroke="white" stroke-width="3" stroke-linecap="round" />
                    </svg>


                </div>


            </div>

        </div>
        {
            !isTransparentMenu &&
            <div className="h-[49px] lg:h-[66px]">

            </div>
        }

        <div className={`${location.pathname == "/login" ? " " : ""} ${isTransparentMenu ? "" : "bg-black bg-opacity-100"} fixed lg:hidden left-0 top-0 w-full  h-[60px]  z-20 px-8`} >

            <div className="relative w-full h-full flex justify-between items-center ">

                <Link to={'/'} className="relative " >
                    <img className=" object-contain w-full h-[21px] " src={titleLogoImg} alt="" />
                </Link>

                <div className="w-6 h-6">
                    <svg className="w-full h-full object-contain cursor-pointer" onClick={() => setShowStoryMenu(true)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">
                        <path d="M3 6H7.125M25 6H12.625M25 23H20.875M3 23H15.375M3 14.5H25" stroke="white" stroke-width="3" stroke-linecap="round" />
                    </svg>
                </div>





            </div>

        </div>

        <ActionDialog />
        <AlertDialog />



    </div >

}
export default Header